<template>
  <div id="group_center_outer" v-if="user != null" class="container-fluid vue_body_min_height" style="padding: 0;">
    <div id="group_top_menu_out" class="container">
      <div id="group_top_menu">
        <a v-for="(item, index) in menuTabList"
           :class="[currentTabId == item.id ? specifiedActive : '', specifiedANormal]"
           href="javascript:void(0);"
           @click="topMenuClicked(item)"
        >
          {{item.label}}
        </a>
      </div>
    </div>

    <div class="group_info_body container">
      <router-view />
<!--      <group-home-page  v-if="currentTabId == allItemList[0].id" />-->
<!--      <group-memeber v-if="currentTabId == allItemList[1].id" />-->
<!--      <personal-vips-detail  v-if="currentTabId == allItemList[2].id" />-->
<!--      <user-training-list v-if="currentTabId == allItemList[3].id"-->
<!--                          v-bind:list-data="orderList"-->
<!--                          v-on:trainDataUpdate="updateTrainData" />-->
<!--      <group-vip-application v-else-if="currentTabId == allItemList[4].id" />-->
<!--      <personal-setting  v-if="currentTabId == allItemList[5].id" />-->
<!--      <personal-notification-center  v-if="currentTabId == allItemList[6].id" />-->
    </div>

  </div>
</template>

<script>
  import PersonalHomePage from "../components/personal/PersonalHomePage";
  import PersonalInformation from "../components/personal/PersonalInformation";
  import PersonalGroup from "../components/personal/PersonalGroup";
  import PersonalVipsDetail from "../components/personal/PersonalVipsDetail";
  import PersonalDaySign from "../components/personal/PersonalDaySign";
  import PersonalSetting from "../components/personal/PersonalSetting";
  import PersonalNotificationCenter from "../components/personal/PersonalNotificationCenter";

  import GroupHomePage from "../components/group/GroupHomePage";
  import GroupMemeber from "../components/group/GroupMember";
  import GroupVipApplication from "../components/group/GroupVipApplication";
  import EventManager from "../js/event-common";
  import UserTrainingList from "../components/common/UserTrainingList";
  import {Loading} from "element-ui";

  export default {
    name: "GroupCenterPage",
    components: {
      GroupVipApplication,
      GroupHomePage,
      GroupMemeber,
      PersonalNotificationCenter,
      PersonalSetting,
      PersonalDaySign,
      PersonalVipsDetail,
      PersonalGroup,
      PersonalInformation,
      PersonalHomePage,
      UserTrainingList,
    },
    data() {
      return {

        flag: 'group-center-page',
        orderList: null,
        menuTabList: null,
        currentTabId: null,
        allItemList: [
          {
            label: '团体主页',
            id: 'home',
            show: true,
            params: {},
            vueName: 'groupHomeVue'
          },
          {
            label: '旗下成员',
            id: 'team-members',
            show: false,
            params: {},
            vueName: 'groupTeamVue'
          },
          {
            label: '我的会员',
            id: 'member',
            show: false,
            params: {},
            vueName: 'groupMemberVue'
          },
          {
            label: '我的课程',
            id: 'user-trains',
            show: false,
            params: {},
            vueName: 'groupTrainsVue'
          },
          {
            label: '我的申请',
            id: 'member-application',
            show: false,
            params: {},
            vueName: 'groupApplicationVue'
          },
          {
            label: '账户设置',
            id: 'user-setting',
            show: true,
            params: {},
            vueName: 'groupSettingVue'
          },
          {
            label: '通知中心',
            id: 'user-notes',
            show: true,
            params: {},
            vueName: 'groupNoteVue'
          },

        ],

        judgeApplyDuration: null,
      }
    },

    watch: {
      $route: {
        handler(val, oldVal) {
          if (this.menuTabList == null) {
            return;
          }
          let route = val;
          let name = route.name;
          let selectedItem = null;
          let selectedIndex = null;
          let menuList = this.menuTabList;
          for (let i = 0; i < menuList.length; i++) {
            let item = menuList[i];
            if (item.vueName == name) {
              selectedItem = item;
              selectedIndex = i;
              break;
            }
          }

          if (selectedItem != null) {
            this.currentTabId = selectedItem.id;
          } else {
            this.initCurrentTabId();
            this.dealWithMenuTabList();
          }
        },
        deep: true
      }
    },
    computed: {
      isOfficialOpened() {
        let judgeApplyDuration = this.judgeApplyDuration;
        if (judgeApplyDuration == null) {
          return false;
        }
        let beginString = judgeApplyDuration.begin;
        let enditString = judgeApplyDuration.end;
        let beginDate = this.$moment(beginString);
        let endDate = this.$moment(enditString);
        let now = this.$moment(this.$moment().format("yyyy-MM-DD"), "yyyy-MM-DD");
        console.log(beginString);
        console.log(enditString);
        if ((now - beginDate) >= 0 && (now - endDate) <= 0) {
          return true;
        }
        return false;
      },

      httpManager() {
        return this.$store.state.http;
      },
      showApplication() {
        return this.$route.params.showApplication;
      },

      specifiedANormal() {
        return this.isVip ? "group-top-menu-a-gold" : "group-top-menu-a-red"
      },
      specifiedActive() {
        return this.isVip ? "group-top-menu-a-gold-active" : "group-top-menu-a-red-active";
      },
      tabList() {
        return this.isVip ? this.vipTabList : this.noVipTabList;
      },

      typeNameAllowedList() {
        return this.$store.state.typeNameAllowedList
      },
      isCanVipOperated() {
        let user = this.user;
        if (user == null) {
          return false;
        }
        let typeName = user.typeName;
        if (typeName == null || typeName == '' || this.typeNameAllowedList.indexOf(typeName) >= 0) {
          return true;
        }
        return false;
      },

      isVip() {
        if (this.user == null) {
          return false;
        }
        let user = this.user;
        let memberValidDate = user.memberValidDate;
        if (memberValidDate == null) {
          return false;
        }
        return this.$moment(memberValidDate).add('1','days').add('-1', 'seconds').isAfter(this.$moment());
      },
      user() {
        return this.$store.state.user;
      }
    },
    mounted() {
      this.$store.commit('setUser', null);
      this.loadData();
      this.getJudgeIdentificationDateDuration();
      this.loadUserOrderData();
      this.initCurrentTabId();
      let _this = this;
      EventManager.register(this.flag, EventManager.notificationNameObject.VipApplyCancel, function (data) {
        _this.currentTabId = _this.allItemList[0].id;
      });

      EventManager.register(this.flag, EventManager.notificationNameObject.UserUpdate, function (data) {
        _this.loadData();
      });

    },
    destroyed() {
      EventManager.unregisterAllEvents(this.flag);
    },
    methods: {
      getJudgeIdentificationDateDuration() {
        let judgeApplyDuration = this.judgeApplyDuration;
        if (judgeApplyDuration == null) {
          let _this = this;
          this.httpManager.ajax.getJudgeApplyDateData(function (data) {
            if (data.code == 0) {
              let value = data.data.value;
              let duration = JSON.parse(value);
              _this.judgeApplyDuration = duration;
              _this.$store.commit("setJudgeApplyDuration", duration);
              _this.dealWithApplicationPage();
              return;
            }
          }, function (data) {

          });
        }
      },


      initCurrentTabId() {
        let route = this.$route;
        let name = route.name;
        for (let i = 0; i < this.allItemList.length; i++) {
          let item = this.allItemList[i];
          if (item.vueName == name) {
            this.currentTabId = item.id;
            this.allItemList[i].show = true;
            break;
          }
        }

        this.dealWithMenuTabList();
        // if (this.currentTabId == null) {
        //   if (name != this.certApplyItem.vueName) {
        //     this.$router.push({
        //       name: this.allItemList[0].vueName
        //     });
        //   }
        // }
      },

      updateTrainData(res) {
        this.orderList = res.data;
      },

      dealWithMenuTabList() {
        let tmp = [];
        for (let item of this.allItemList) {
          if (item.show) {
            tmp.push(item);
          }
        }
        this.menuTabList = tmp;
        if (this.currentTabId == null) {
          this.currentTabId = tmp[0].id;
          this.topMenuClicked(tmp[0]);
        }
      },

      loadUserOrderData() {
        let _this = this;
        this.httpManager.ajax.getUcOrdersData(function (data) {
          let code = data.code;
          if (code == 0) {
            let tempList = data.data;
            if (tempList == null || tempList.length == 0) {
              return;
            } else {
              let list = [];
              for (let item of tempList) {
                if (item.productId == 0 || item.productId == -1 || item.productId == -2) {
                  continue;
                }
                list.push(item);
              }
              if (list.length == 0) {
                return;
              }
              _this.orderList = list;
              _this.allItemList[3].show = true;
              _this.dealWithMenuTabList();
            }

          }
        }, function (data) {

        });
      },


      topMenuClicked(item) {
        this.currentTabId = item.id;
        this.$router.push({
          name: item.vueName,
          params: item.params
        });
      },


	  updateModifiedValue(modified, callback) {
	    let user = this.user;
	    if (user == null) {
	      return;
	    }
	    let params = {};
	    params.id = user.id;
	    params.modified = modified;

	    this.httpManager.ajax.postUserModifiedChangeRequest(params, function (data) {
	      let code = data.code;
	      if (code == 0) {
	        callback();
	        return;
	      }
	      _this.$toast('更新失败！');
	    }, function (data) {
	      _this.$toast('更新失败，请重试！');
	    });
	  },

	  updateAuditStatus(status, callback) {
	    let user = this.user;
	    if (user == null) {
	      return;
	    }
	    let params = {};
	    params.id = user.id;
	    params.auditStatus = status;
	    let _this = this;
	    this.httpManager.ajax.postUpdateUserAuditStatusRequest(params, function (data) {
	      let code = data.code;
	      if (code == 0) {
	        callback();
	        return;
	      }
	      _this.$toast('更新失败！');
	    }, function (data) {
	      _this.$toast('更新失败，请重试！');
	    });
	  },

      closeUserMemberApplication() {
        if (this.judgeApplyDuration == null) {
          return;
        }
        let _this = this;
        let user = this.user;
        let neededUpdateModified = false;
        if (user.modified != 0) {
        		  neededUpdateModified = true;
        }

        this.updateAuditStatus(0, function() {
        		  if (neededUpdateModified) {
        			  _this.updateModifiedValue(0, function() {
        				  _this.loadData();
        			  })
        		  }
        });
      },

      dealWithApplicationPage() {
        if (!this.isCanVipOperated) {
          this.allItemList[2].show = false;
          this.allItemList[4].show = false;
          return;
        }

        let user = this.user;
        let status = user.status;
        let memberValidDate = user.memberValidDate;
        let auditStatus = user.auditStatus;

        if (auditStatus > 0) { // 已然开始 会员申请或者审核
          if (memberValidDate != null) {
            this.allItemList[4].label = "会员激活";
          } else {
            this.allItemList[2].show = false;
          }

          if (status == 3) {
            this.allItemList[4].show = true;
            return;
          }

          // 窗口期...
          if (this.isOfficialOpened) {
            this.allItemList[4].show = true;
          } else {
            //...更新状态
            console.log('-- update audit status');
            this.closeUserMemberApplication();
          }
        } else {
          if (status == 3) { // 已然是会员
            this.allItemList[2].show = true;
          }
          this.allItemList[4].show = false;
        }
        this.initCurrentTabId();
      },

      loadData() {
        let _this = this;
        let loadFlags = null;
        if (this.user == null) {
          loadFlags = Loading.service({
            target: document.getElementById('app'),
            fullscreen: true
          });
        }
        this.$store.state.http.ajax.ucProfile(function (data) {
          console.log(data);
          if (loadFlags != null) {
            loadFlags.close();
          }
          let code = data.code;
          if (code == 0) {
            let user = data.data;
            let isTeam = user.isTeam;
            console.log(user);
            if (isTeam == 0) {
              let params = _this.$route.params;
              let l = _this.$router.resolve({
                name: 'personalPage',
                params
              });
              window.location.href = l.href;
              return;
            }
            _this.$store.commit('setUser', user);
            _this.dealWithApplicationPage();
            if (_this.isVip) {
              _this.allItemList[2].show = true;
              _this.allItemList[1].show = true;
            } else {
              _this.allItemList[2].show = false;
              _this.allItemList[1].show = false;
            }
            _this.dealWithMenuTabList();
          } else {
            _this.$toast('请求失败！');
          }
        }, function (data) {
          if (loadFlags != null) {
            loadFlags.close();
          }
          console.log(success);
          _this.$toast('请求失败，请重试！');
        })
      },
    }
  }
</script>

<style scoped>

  #group_center_outer {
    background-image: url("../assets/shl_personal_center_top_bg.png");
    background-size: auto 100px;
    background-repeat: no-repeat;
    background-position: center top;
    background-color: white;
  }

  #group_top_menu_out {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 115px;
  }

  #group_top_menu {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .group-top-menu-a-gold, .group-top-menu-a-red {
    color: #333;
  }

  .group-top-menu-a-gold-active, .group-top-menu-a-red-active {
    pointer-events: none;
  }

  .group-top-menu-a-gold:hover, .group-top-menu-a-gold-active{
    color: #cbb042;
  }

  .group-top-menu-a-gold-active {
    border-bottom: solid 2px #cbb042;
  }

  .group-top-menu-a-red:hover, .group-top-menu-a-red-active{
    color: #e71432;
  }
  .group-top-menu-a-red-active {
    border-bottom: solid 2px #e71432;
  }


  #group_top_menu > a {
    text-decoration: none;
    font-size: 1.5rem;
    margin-left: 15px;
    padding-top: 5px;
    padding-bottom: 5px;
    text-align: center;
  }

  .group_info_body {
    padding-bottom: 30px;
    margin-top: 15px;
    padding-left: 0;
    padding-right: 0;
  }

</style>



// WEBPACK FOOTER //
// src/pages/GroupCenterPage.vue